import React from "react";
import styles from "./titulo-escenario.module.css"

const TituloEscenario = ({ titulo, subTitulo, sup }) => {
    return (
        <div className={styles.contenedor}>
            <span className={styles.titulo}>
                {titulo}
                {sup !== undefined
                    ? <sup className={styles.subfijo}>{sup}</sup>
                    : null
                }
            </span>
            
            {subTitulo !== undefined
                ? <span className={styles.sub_titulo}>
                    {subTitulo}
                </span>
                : null
            }
        </div>
    )
}

export default TituloEscenario;